var _defs, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgNightDecoratorMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 416.254,
    height: 51.131,
    viewBox: "0 0 416.254 51.131",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#417693"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2b4a64"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_9163",
    "data-name": "Path 9163",
    d: "M60.1,804.353H216.354c0-24.765-30.133-29.789-46.934-30.3-14.613-.471-18.243-23.745-42.723-20.526-14.8,1.962-15.73,12.6-28.715,14.953C86.534,770.561,60.1,779.234,60.1,804.353Z",
    transform: "translate(199.9 -753.222)",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9164",
    "data-name": "Path 9164",
    d: "M60.1,804.353H216.354c0-24.765-30.133-29.789-46.934-30.3-14.613-.471-18.243-23.745-42.723-20.526-14.8,1.962-15.73,12.6-28.715,14.953C86.534,770.561,60.1,779.234,60.1,804.353Z",
    transform: "translate(-60.1 -753.222)",
    fill: "url(#linear-gradient)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgNightDecoratorMobile);
export default __webpack_public_path__ + "static/media/bg-night-decorator-mobile.202dcd53d00921240d146360c9312099.svg";
export { ForwardRef as ReactComponent };